export const MOBILE_TYPE = 1;
export const DESKTOP_TYPE = 2;
export const TSD_TYPE = 3;

export const MOBILE_PRICE = 12000;
export const DESKTOP_PRICE = 15000;
export const TSD_PRICE = 30000;
